var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickIcon = function SvgTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10.1146L12.7945 3.98596L13.7378 4.92863L6.6665 12L2.42383 7.7573L3.3665 6.81463L6.6665 10.1146Z",
    fill: "#37434C"
  })));
};
export { SvgTickIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjY2NSAxMC4xMTQ2TDEyLjc5NDUgMy45ODU5NkwxMy43Mzc4IDQuOTI4NjNMNi42NjY1IDEyTDIuNDIzODMgNy43NTczTDMuMzY2NSA2LjgxNDYzTDYuNjY2NSAxMC4xMTQ2WiIgZmlsbD0iIzM3NDM0QyIvPgo8L3N2Zz4K";